import { NoteMessage } from '@/@types/messages/NoteMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'
import { ObjectCreatedResponse } from '@/@types/responses/common/ObjectCreatedResponse'
import { UpdateQuotePartMessage } from '@/@types/messages/UpdateQuotePartMessage'
import { UpdateQuotePartsMessage } from '@/@types/messages/UpdateQuotePartsMessage'

export class QuotePartService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public createQuotePartNote(quotePartId: number, noteMessage: NoteMessage): Promise<ObjectCreatedResponse<number>> {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(noteMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-parts/${quotePartId}/notes`, this.miscellaneousService, requestOptions).then(async response => {
      const json = await response.json()
      return new ObjectCreatedResponse<number>(json.id)
    })
  }

  public deleteQuotePart(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-parts/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateQuotePart(quotePartId: number, updateQuotePartMessage: UpdateQuotePartMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateQuotePartMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-parts/${quotePartId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public updateQuoteParts(updateQuotePartsMessage: UpdateQuotePartsMessage): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updateQuotePartsMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/quote-parts`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}